module.exports = __webpack_public_path__ + "img/bg-careers-tablet-portrait.5a666ddb.png";